// Monaco se sirve desde la propia imagen, no desde un CDN.
//
// `@monaco-editor/react` sin configurar descarga Monaco de jsdelivr en tiempo de
// ejecución. Lo descarga el NAVEGADOR del operador, no el servidor: en una red de gestión
// sin salida a internet —bastante común en el público de ENTROPY— el editor no carga y la
// pantalla queda en blanco sin decir por qué.
//
// Los archivos llegan a `public/monaco/vs` con scripts/copy-monaco.js, enganchado en
// `prestart` y `prebuild`.
//
// Esto NO es de Niko: se importa desde index.js y alcanza a todos los editores de la app
// —plantillas, variables, y los de la sección de Niko— con una sola configuración. Vive
// fuera de `features/niko` a propósito, porque el build core también lo necesita.
import { loader } from '@monaco-editor/react';

// Ruta absoluta desde la raíz del sitio. La app se sirve en `/` (no hay `homepage` en
// package.json); si algún día se sirviera bajo un subpath, esto hay que acompañarlo.
loader.config({ paths: { vs: '/monaco/vs' } });
